import { fromAsync } from "../../async/static/fromAsync.js";
export const selectAsync = (source, selector) => {
    if (typeof selector === "function") {
        if (selector.length === 1) {
            return selectAsync1(source, selector);
        }
        else {
            return selectAsync2(source, selector);
        }
    }
    else {
        return selectAsync3(source, selector);
    }
};
const selectAsync1 = (source, selector) => {
    async function* iterator() {
        for (const value of source) {
            yield selector(value);
        }
    }
    return fromAsync(iterator);
};
const selectAsync2 = (source, selector) => {
    async function* iterator() {
        let index = 0;
        for (const value of source) {
            yield selector(value, index);
            index++;
        }
    }
    return fromAsync(iterator);
};
const selectAsync3 = (source, key) => {
    async function* iterator() {
        for (const value of source) {
            yield value[key];
        }
    }
    return fromAsync(iterator);
};
